const allFeatures = [
  "matrix_filter_2",
  "isFree",
  "edit_salary_restriction",
  "edit_housing_restriction",
  "edit_investment_restriction_free",
  "edit_investment_restriction_plus",
  "city_search_result_restriction",
  "role_selection_restriction_2",
  "role_selection_restriction_1",
  "matrix_filter",
];

const planRestrictions = {
  Free: [
    "isFree",
    "edit_salary_restriction",
    "edit_housing_restriction",
    "role_selection_restriction_1",
    "city_search_result_restriction",
    "edit_investment_restriction_free",
    "matrix_filter",
  ],
  Plus: [
    "role_selection_restriction_2",
    "edit_salary_restriction",
    "edit_housing_restriction",
    "city_search_result_restriction",
    "edit_investment_restriction_plus",
    "matrix_filter_2",
  ],
  Pro: [],
  Free_trial: [],
};

function isExpired(dateString) {
  const expireDate = new Date(dateString);
  const now = new Date();
  return now > expireDate;
}

// If you want to use the adjusted expiry version, replace above with:
// function isExpired(dateString) {
//   const expireDate = new Date(dateString);
//   const adjustedExpiry = new Date(expireDate);
//   adjustedExpiry.setUTCDate(expireDate.getUTCDate() + 1);
//   return new Date() >= adjustedExpiry;
// }

function getFeatureAccess(user) {
  const expired = isExpired(user?.expiryDate);
  // When expired, fall back to Free restrictions regardless of which plan
  // the user is on. Otherwise apply restrictions for the user's actual plan;
  // unknown / missing plan names default to Free.
  const effectivePlan = expired ? "Free" : (user?.plan?.name || "Free");

  const restrictedFeatures = new Set(planRestrictions[effectivePlan]);

  const access = {
    __planExpired: expired,
  };

  allFeatures.forEach((feature) => {
    access[feature] = restrictedFeatures.has(feature);
  });

  return access;
}

export { getFeatureAccess, isExpired };
